// Deprecated. Please refrain from new usage
import React from "react";
import PropTypes from "prop-types";
import { withStyles, withTheme } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeaderWithTopRight from "./CardHeaderWithTopRight";
import ActionButtons from "./ActionButtons";
import useMediaQuery from "../../hooks/useMediaQuery";

const style = () => ({
  root: {
    borderRadius: 0,
    height: "100%",
    position: "relative",
  },
  cardContent: {
    margin: 0,
  },
});

const MediumWidget = (props) => {
  const isMobile = useMediaQuery(props.theme.breakpoints.down("sm"));
  return (
    <Grid
      item
      xs={12}
      md={8}
      style={{
        padding: isMobile ? "0 32px" : 10,
        marginBottom: isMobile && 10,
      }}
    >
      <Card className={props.classes.root}>
        {!props.customHeader && (
          <CardHeaderWithTopRight
            title={props.title}
            background={props.headerBackground}
            height={props.headerHeight}
            color={props.headerText}
          >
            {props.topRight}
          </CardHeaderWithTopRight>
        )}
        {!!props.customHeader && props.customHeader}
        <CardContent className={props.classes.cardContent} style={{ padding: 0 }}>
          {props.children}
        </CardContent>
        {props.buttons.length !== 0 && (
          <ActionButtons buttons={props.buttons}>{props.bottomLeft}</ActionButtons>
        )}
        {!props.buttons && props.bottomLeft && <div>{props.bottomLeft}</div>}
      </Card>
    </Grid>
  );
};

MediumWidget.propTypes = {
  title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  customHeader: PropTypes.node,
  buttons: PropTypes.array,
  topRight: PropTypes.node,
  children: PropTypes.node,
  bottomLeft: PropTypes.node,
  headerBackground: PropTypes.string,
  headerHeight: PropTypes.string,
  headerText: PropTypes.string,
};

MediumWidget.defaultProps = {
  customHeader: null,
  title: null,
  buttons: [],
  topRight: null,
  children: null,
  bottomLeft: null,
  headerBackground: null,
  headerHeight: null,
  headerText: null,
};

export default withStyles(style)(withTheme(MediumWidget));
